import { JobAdFeatureChart } from '../JobAdFeatureChart/JobAdFeatureChart';
import type { SiteName } from '@seek/melways-sites';
import type * as React from 'react';

import type { ArticleAdditionalData } from '../Article/types';

import { FastestGrowingSalaries } from './FastestGrowingSalaries/FastestGrowingSalaries';
import { GenerationalDriversSummary } from './GenerationalDrivers/GenerationalDrivers';
import { GenerationalDriversInteractive } from './GenerationalDrivers/GenerationalDriversInteractive';
import { HighestPayingJobs } from './HighestPayingJobs/HighestPayingJobs';
import { EmbededQueryFilterTAL } from './QueryFilterTAL/EmbededQueryFilterTAL';
import { TopJobGrowth } from './TopJobGrowth/TopJobGrowth';
import { useCMSUContext } from '../../hooks';

export type EmbeddedContentTitle =
  | 'FASTEST_GROWING_SALARIES'
  | 'HIGHEST_PAYING_JOBS'
  | 'GENERATION_DRIVERS_SUMMARY'
  | 'GENERATION_DRIVERS_INTERACTIVE'
  | 'QUERY_FILTER_TAL'
  | 'TOP_JOB_GROWTH'
  | 'JOBAD_FEATURE_CHART';
interface Props {
  title: string;
  additionalData?: ArticleAdditionalData;
}
export const EmbeddedCustomContent = ({ title, additionalData }: Props) => {
  const { country, site } = useCMSUContext();
  const content = EmbeddedContentMapping[title] ? (
    EmbeddedContentMapping[title](country, site, additionalData)
  ) : (
    <div>--</div> // Fallback if no content is found
  );
  return <>{content}</>;
};

export const EmbeddedContentMapping: Record<
  string,
  (
    country: string,
    site: SiteName,
    additionalData?: ArticleAdditionalData,
  ) => React.ReactNode
> = {
  FASTEST_GROWING_SALARIES: () => <FastestGrowingSalaries />,
  HIGHEST_PAYING_JOBS: () => <HighestPayingJobs />,
  GENERATION_DRIVERS_SUMMARY: (country: string) => (
    <GenerationalDriversSummary country={country} />
  ),
  GENERATION_DRIVERS_INTERACTIVE: (country: string) => (
    <GenerationalDriversInteractive country={country} />
  ),
  TOP_JOB_GROWTH: () => <TopJobGrowth />,
  QUERY_FILTER_TAL: (
    country: string,
    site: SiteName,
    additionalData?: ArticleAdditionalData,
  ) => <EmbededQueryFilterTAL datalabSurvey={additionalData?.datalabSurvey} />,
  JOBAD_FEATURE_CHART: (country: string, site: SiteName) => (
    <JobAdFeatureChart embed={true} site={site} />
  ),
};
